import React, { useState } from 'react';

import EmptyList from '../useful/EmptyList';
import TeamListForm from './TeamListForm';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TeamListItem from './TeamListItem';
import TeamListLoader from '../loaders/TeamListLoader';
import { withFirebase } from '../firebase';
import ModalInfo from '../useful/ModalInfo';
import ModalForm from '../useful/ModalForm';

const TeamList = (props) => {


    const { tournament, loading, teams } = props;

    const [modal, setModal] = useState({ show: false, title: '', message: '' });
    const [formShow, setFormShow] = useState(false);

    const showModal = (title, message) => {
        setModal({ show: true, title, message });
    }

    const tableHead =
        <thead className="">
            <tr >
                <th className="" style={{ width: 40 }}></th>
                <th className="pl-0" >NOMBRE</th>
                <th className="text-center" style={{ width: 25.5 }}>
                    <span className="d-none d-sm-table-cell">JUGADORES</span>
                    <span className="d-table-cell d-sm-none">JUG</span>
                </th>
                <th className="text-center" style={{ width: 50 }}></th>
            </tr>
        </thead>


    const loadindList = [0, 1, 2, 3].forEach((i) => {
        return (
            <TeamListLoader key={i} index={i} />
        )
    })
    const loadingView =
        <table className="table table-sm table-hover small ">
            {tableHead}
            <tbody>
                {loadindList}
            </tbody>
        </table>

    const disabled = loading || (tournament && (tournament.matchesGenerated || tournament.matchesGroupGenerated));

    const listView = (teams && teams.length > 0) ?
        teams.map((item, i) => {
            if (item)
                return (
                    <TeamListItem key={i}
                        showModal={showModal}
                        item={item}
                        index={i + 1}
                        disabled={disabled} />
                )
        })
        :
        <tr>
            <td colSpan="10"><EmptyList /></td>
        </tr>

    let countText = "";
    if (!loading && teams) {
        const teamCount = (teams.length || "0");
        countText = ": " + teamCount;
    }

    return (
        <div className="">
            <div className="row justify-content-between m-0 mb-2 small">
                <span className="col-auto align-self-center font-weight-bolder m-0 p-0">
                    Equipos{countText}
                </span>

                <button disabled={disabled} onClick={() => setFormShow(true)} className="btn btn-light btn-sm col-auto" type="button" >
                    <FontAwesomeIcon className="mr-2" icon={faPlus} />
                    Añadir Equipo
                </button>
            </div>

            <div className="table-responsive-sm">
                {(!loading) ?

                    <table className="table table-sm small ">
                        {tableHead}
                        <tbody>
                            {listView}
                        </tbody>
                    </table>
                    :
                    <div className="row m-0">
                        {loadingView}
                    </div>
                }
            </div>


            {/* TeamForm Modal */}
            <ModalForm
                show={formShow}
                onClose={() => setFormShow(false)}
            >
                <TeamListForm onClose={() => setFormShow(false)} showModal={showModal} isOpen={formShow} />
            </ModalForm>

            {/* Message Modal */}

            <ModalInfo
                data={modal}
                onClose={() => setModal({ show: false, title: '', message: '' })}
            />

        </div>
    )
}

// const condition = authUser => {
//     if (!!authUser) {
//         return authUser.token.admin || authUser.token.premium;
//     } else
//         return false;
// };
export default withFirebase(TeamList);